export default "__VITE_ASSET__DHzYzumx__"